
import React from 'react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { PlusCircle } from 'lucide-react';
import CreateReportDialog from '@/components/admin/CreateReportDialog';

interface RoyaltyReportsFiltersProps {
  yearFilter: string;
  statusFilter: string;
  authorFilter: string;
  countryFilter: string;
  onYearFilterChange: (value: string) => void;
  onStatusFilterChange: (value: string) => void;
  onAuthorFilterChange: (value: string) => void;
  onCountryFilterChange: (value: string) => void;
  years: number[];
  statuses: string[];
  countries: string[];
  authors?: Array<{ id: string; name: string }>;
}

const RoyaltyReportsFilters: React.FC<RoyaltyReportsFiltersProps> = ({
  yearFilter,
  statusFilter,
  authorFilter,
  countryFilter,
  onYearFilterChange,
  onStatusFilterChange,
  onAuthorFilterChange,
  onCountryFilterChange,
  years,
  statuses,
  countries,
  authors
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      <Select value={yearFilter} onValueChange={onYearFilterChange}>
        <SelectTrigger className="w-[120px]">
          <SelectValue placeholder="Year" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Years</SelectItem>
          {years.map(year => (
            <SelectItem key={year} value={year.toString()}>
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="w-[120px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Statuses</SelectItem>
          {statuses.map(status => (
            <SelectItem key={status} value={status}>
              {status}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      <Select value={authorFilter} onValueChange={onAuthorFilterChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Author" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Authors</SelectItem>
          {authors?.map(author => (
            <SelectItem key={author.id} value={author.id}>
              {author.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      <Select value={countryFilter} onValueChange={onCountryFilterChange}>
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="Country" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Countries</SelectItem>
          {countries.map(country => (
            <SelectItem key={country} value={country}>
              {country}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      <CreateReportDialog trigger={
        <Button>
          <PlusCircle className="h-4 w-4 mr-2" />
          Create Report
        </Button>
      } />
    </div>
  );
};

export default RoyaltyReportsFilters;
